import * as React from 'react'
import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import CollectionsBootstrap from 'modules/documents/lib/My_documentsCollectionsBootstrap'
import { CommonRouteContext } from 'modules/employees/lib/types'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

export interface Tab {
  href: string
  name: string
}

interface RouteContext extends CommonRouteContext {}

const isAuthorized = (employee: Employee | undefined): boolean => {
  if (!employee) return false

  // TODO: readDocuments is now seeDocuments
  return employee.policy.can('readDocuments')
}

const Container = () => {
  const { employee: sessionEmployee } = useCurrentSession()
  const employee = sessionEmployee
    ? employees.find({
        id: sessionEmployee.id,
      })
    : undefined
  const cardEmployeeRight = React.useRef<HTMLElement | null>(null)
  const headerTitle = React.useRef<HTMLElement | null>(null)

  if (!employee) return <NotFound />

  const context: RouteContext = {
    employee,
    cardEmployeeRight,
    headerTitle,
    canSeePersonalInfo: false,
    canEditPersonalInfo: false,
  }

  return (
    <AuthorizeUser authorizeFn={() => isAuthorized(employee)}>
      <Outlet context={context} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
